import { deviceStorage } from '../../../storage/deviceStorage';

export const hasAskedHere = (): boolean => deviceStorage.read('pushAsked') !== null;

export const rememberAskedHere = (at: string): void => deviceStorage.write('pushAsked', at);
